<template>
<div class="main_box">
    <a-spin :spinning="chartloading">
        <div class="sumBlock">
            <div class="sumItem">
                <div class="sumval">{{errcount}}</div>
                <div class="sumtitle">js错误总数</div>
                <div class="sumtongbi">
                    <span>同比</span>
                    <span :class="[errGrowPercent[0] == '-' ? 'greenClass' : 'redClass']">
                        {{errGrowPercent}}
                        <a-icon v-if="errGrowPercent" style="margin-left:4px;"
                            :type="errGrowPercent[0] == '-' ? 'arrow-down' : 'arrow-up'" />
                    </span>
                </div>


            </div>
            <div class="sumhuanbi">
                <a-button type="link" @click="handleDetail(1)">查看详情</a-button>
            </div>
        </div>

        <div class="sumBlock ogItem">
            <div class="sumItem">
                <div class="sumval">{{clicktime}}</div>
                <div class="sumtitle">点击量</div>
                <div class="sumtongbi">
                    <span>同比</span>
                    <span :class="[clicktimeGrowPercent[0] == '-' ? 'redClass' : 'greenClass']">
                        {{clicktimeGrowPercent}}
                        <a-icon v-if="clicktimeGrowPercent" style="margin-left:4px;"
                            :type="clicktimeGrowPercent[0] == '-' ? 'arrow-down' : 'arrow-up' " />
                    </span>
                </div>
            </div>

            <div class="sumhuanbi">
                <a-button type="link" @click="handleDetail(2)">查看详情</a-button>
            </div>
        </div>

        <div class="sumBlock topItem">
            <div class="sumItem">
                <div class="sumval">{{TP90}}</div>
                <div class="sumtitle">API耗时TP90</div>
                <div class="sumtongbi">
                    <span>同比</span>
                    <span :class="[TP90GrowPercent[0] == '-' ? 'greenClass':'redClass']">
                        {{TP90GrowPercent}}
                        <a-icon v-if="TP90GrowPercent" style="margin-left:4px;"
                            :type="TP90GrowPercent[0] == '-' ? 'arrow-down' : 'arrow-up' " />
                    </span>
                </div>
            </div>

            <div class="sumhuanbi ">
                <a-button type="link" @click="handleDetail(3)">查看详情</a-button>
            </div>
        </div>

        <div class="sumBlock ogItem topItem">
            <div class="sumItem">
                <div class="sumval">{{resourcecount}}</div>
                <div class="sumtitle">慢资源数</div>
                <div class="sumtongbi">
                    <span>同比</span>
                    <span :class="[resourcecountGrowPercent[0] == '-' ? 'greenClass' : 'redClass' ]">
                        {{resourcecountGrowPercent}}
                        <a-icon v-if="resourcecountGrowPercent" style="margin-left:4px;"
                            :type="resourcecountGrowPercent[0] == '-' ? 'arrow-down' : 'arrow-up' " />
                    </span>
                </div>
            </div>

            <div class="sumhuanbi">
                <a-button type="link" @click="handleDetail(4)">查看详情</a-button>
            </div>
        </div>
    </a-spin>
</div>
    
</template>

<script>

export default {
    data(){
        return {
            tempHostName:'',
            tempEnv:'',
            tempTimeRange:'',
            chartloading:false,
            //异常数
            errcount:0,
            errGrowPercent:'',
            //点击量
            clicktime:0,
            clicktimeGrowPercent:'',
            //api耗时
            TP90:0,
            TP90GrowPercent:'',
            //超时资源数
            resourcecount:0,
            resourcecountGrowPercent:''
        }
    },
    methods:{
        handleDetail(flag){
            let timeRange = this.tempTimeRange;
            if(flag == 1){
                this.$router.push({
                    path: '/monitorweb/monitor'
                })
            }
            else if(flag == 2){
                this.$router.push({
                    path: '/monitorweb/logs',
                    query:{
                        logType:'click',
                        timeRange:timeRange
                    }
                })
            }
            else if(flag == 3){
                this.$router.push({
                    path: '/monitorweb/logs',
                    query:{
                        logType:'api',
                        timeRange:timeRange
                    }
                })
            }
            else if(flag == 4){
                this.$router.push({
                    path: '/monitorweb/logs',
                    query:{
                        logType:'resource',
                        timeRange:timeRange
                    }
                })
            }
            else{
                this.$router.push({
                    path: '/monitorweb/performance',
                })
            }
        },
        loadData(selectedEnv,hostName,timeRange){
            this.tempHostName = hostName;
            this.tempEnv = selectedEnv;
            this.tempTimeRange = timeRange;
            this.errcount = 0;
            this.errGrowPercent = '';
            let that = this;
            timeRange = timeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            let timeSeries = ( (new Date(timeRange[1])).getTime() - (new Date(timeRange[0])).getTime()) / 1000;
            

            let queryStr = "* | select compare(errcount, "+timeSeries+") as errcount from "+
                    " (select count(1) as errcount from log where project_name = '"+hostName+"' and log_type='js-error')";
                    
            that.chartloading = true;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let targetData = JSON.parse(res.data.data.list[0].errcount);
                    that.errcount = targetData[0];
                    if(targetData[2] != 'NaN' && targetData[2] != 'Infinity'){
                        that.errGrowPercent = ((parseFloat(targetData[2]) - 1) * 100).toFixed(2)  + '%';
                    }
                    
                }
            }).catch(() => {
            });
           
           
            //点击量
            params.sql = "* | select compare(clicktime, "+timeSeries+") as clicktime from "+ "( select count(1) as clicktime from log where project_name = '" + hostName + "' and log_type='click')"
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let targetData = JSON.parse(res.data.data.list[0].clicktime);
                    that.clicktime = targetData[0];
                    if(targetData[2] != 'NaN' && targetData[2] != 'Infinity'){
                        that.clicktimeGrowPercent = ((parseFloat(targetData[2]) - 1) * 100).toFixed(2)  + '%';
                    }
                    
                }
            }).catch(() => {
            });

            //api耗时TP90
            params.sql = "* | select compare(TP90, "+timeSeries+") as TP90 from "+ "( select round(approx_percentile(res_duration,0.9),1) as TP90  from log where project_name = '" + hostName + "' and log_type='api')"
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let targetData = JSON.parse(res.data.data.list[0].TP90);
                    if(targetData[0] != 'NaN' && targetData[0] != 'Infinity' && targetData[0] != null){
                        that.TP90 = targetData[0] > 1000 ? ((targetData[0] / 1000).toFixed(1) + 's') : (targetData[0] + 'ms' ) ;
                    }
                    else{
                        that.TP90 = 0
                    }
                    if(targetData[2] != 'NaN' && targetData[2] != 'Infinity' && targetData[2] != null){
                        that.TP90GrowPercent = ((parseFloat(targetData[2]) - 1) * 100).toFixed(2)  + '%';
                    }
                    else{
                        that.TP90GrowPercent = ''
                    }
                    
                }
            }).catch(() => {
            });


            //加载慢资源数
            params.sql = "* | select compare(resourcecount, "+timeSeries+") as resourcecount from "+ "( select count(1) as resourcecount  from log where project_name = '" + hostName + "' and log_type='resource')"
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{

                if(res.status == 200 && res.data.success == '1'){
                    let targetData = JSON.parse(res.data.data.list[0].resourcecount);
                    that.resourcecount = targetData[0];
                    if(targetData[2] != 'NaN' && targetData[2] != 'Infinity'){
                        that.resourcecountGrowPercent = ((parseFloat(targetData[2]) - 1) * 100).toFixed(2)  + '%';
                    }
                    
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },

    },
    mounted(){
    },

    components:{
    },
};
</script>

<style lang="less" scoped>
    .main_box{
        width: 340px;
        height: auto;
        float: left;
    }
    .sumBlock{
        width: 165px;
        height: 187px;
        border: 1px solid lightgray;
        padding: 0 20px;
        position: relative;
        float: left;
    }

    .ogItem{
        margin-left:10px;
    }
    .topItem{
        margin-top:20px;
    }
    .sumItem{
        padding-top: 10px;
        width: 100%;
        display: inline-block;
    }

    .sumval{
        color: #394043;
        font-weight: bold;
        font-size: 30px;
        text-align: center;
    }

    .sumtitle{
        color: #525252;
        font-size: 14px;
        text-align: center;
        margin-bottom: 20px;
    }

    .sumtongbi{
        text-align: center;
        color: #6d8088;
    }

    .greenClass{
        color: #6ac990;
        padding-left: 4px;
    }

    .redClass{
        color: red;
        padding-left: 4px;
    }

    .sumhuanbi{
        width: 100%;
        text-align: center;
        margin-top: 10px;
    }

    
</style>
